module.exports = __webpack_public_path__ + "img/20200810.7841f95d.png";